import { render, staticRenderFns } from "./locationCate.vue?vue&type=template&id=7a570e2b&scoped=true"
import script from "./locationCate.vue?vue&type=script&lang=js"
export * from "./locationCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a570e2b",
  null
  
)

export default component.exports